<template>
  <div class="model-card" :class="{ 'selected-card': isSelected }" @click="$emit('click')">
    <div class="icon-container">
      <mf-icon :icon="card.icon_name" color="marca-0-l10" size="32" />
    </div>
    <div class="card-content">
      <h2>{{ card.name }}</h2>
      <p>{{ card.description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    card: {
      type: Object,
      default: () => ({}),
    },
    selectedCard: {
      type: String,
      default: '',
    },
  },
  computed: {
    isSelected() {
      return Boolean(this.card._id === this.selectedCard)
    },
  },
}
</script>

<style lang="scss" scoped>
.model-card {
  user-select: none;
  cursor: pointer;
  box-shadow: 0px 1px 6px 0px #00000026;
  border-radius: 16px;
  display: grid;
  grid-template-columns: 64px 1fr;

  .icon-container {
    background-color: #d2e9ff33;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top-left-radius: 14px;
    border-bottom-left-radius: 14px;
  }

  .card-content {
    padding: 12px;
    h2 {
      font-size: 16px;
      color: $cinza-d10;
      margin-bottom: 8px;
      line-height: 19.2px;
    }

    p {
      font-size: 14px;
      color: $cinza-0;
      margin-bottom: 0;
      line-height: 20px;
    }
  }
}

.selected-card {
  outline: 2px solid $marca-0-l40;
  box-shadow: 0px 2px 10px 0px #0000000d;
  box-shadow: 0px 2px 12px 0px #0066ff59;
}
</style>
